import { render, staticRenderFns } from "./aiTester.vue?vue&type=template&id=e623cc46"
import script from "./aiTester.vue?vue&type=script&lang=js"
export * from "./aiTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports